import { appSelector } from 'modules/app/appSelector';
import { appSlice } from 'modules/app/appSlice';
import React from 'react';
import { Snackbar } from 'react-native-paper';
import { useDispatch, useSelector } from 'react-redux';

// https://callstack.github.io/react-native-paper/snackbar.html
const Toast: React.VFC = () => {
	const dispatch = useDispatch();
	const { text, visible } = useSelector(appSelector.selectMessage);

	const handleDismiss = () => {
		dispatch(appSlice.actions.hideMessage());
	};

	return (
		<Snackbar visible={visible} onDismiss={handleDismiss} duration={3000}>
			{text}
		</Snackbar>
	);
};

export default Toast;
